import React from 'react';
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import ReactHtmlParser from "react-html-parser";
import {InfoTwoTone} from "@mui/icons-material";
import {withStyles} from "@material-ui/styles";

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: 2,
        fontSize: 12
    },
    title: {
        margin: 5,
        padding: 6,
        border: '2px solid rgba(0,54,123,255)',
        borderRadius: '10px',
        backgroundColor: '#00367b',
        textAlign: 'center',
        color: 'white',
        fontSize: 12
    },
    closeButton: {
        position: 'absolute',
        right: 1,
        top: 1,
        color: 'grey',
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.title} {...other}>
            <Typography>{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: 2,
    },
}))(MuiDialogContent);

function TooltipDialog(props) {

    return (
        <div>
            <Dialog onClose={props.handleClose} aria-labelledby="customized-dialog-title" open={props.open}>
                <DialogTitle id="customized-dialog-title" onClose={props.handleClose}>
                    <InfoTwoTone style={{fontSize: 40}}/> {props.title}
                </DialogTitle>
                <DialogContent dividers>
                    <Typography gutterBottom>
                        { ReactHtmlParser (props.text) }
                    </Typography>
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default TooltipDialog;
